module.exports = __webpack_public_path__ + "static/media/TeleMeditar_Logo_SM.e9280570.png";